module.exports = __webpack_public_path__ + "img/wire-transfer.79bfe293.jpg";